import { getDefaultExportFromCjs as te } from "./ghl-ui.es436.js";
import { __module as z } from "./ghl-ui.es1628.js";
import { i as ae } from "./ghl-ui.es1541.js";
import { i as oe } from "./ghl-ui.es1629.js";
import { s as le } from "./ghl-ui.es1630.js";
import { t as ie } from "./ghl-ui.es1631.js";
import { f as ne } from "./ghl-ui.es1632.js";
import { l as de } from "./ghl-ui.es1633.js";
import { g as fe } from "./ghl-ui.es1634.js";
import "./ghl-ui.es1635.js";
import { t as ue } from "./ghl-ui.es1636.js";
import { r as ve } from "./ghl-ui.es1637.js";
import "./ghl-ui.es1638.js";
import { d as se } from "./ghl-ui.es1639.js";
import { __exports as me } from "./ghl-ui.es1640.js";
import { __exports as ce } from "./ghl-ui.es1641.js";
(function(Y, v) {
  var t = ae.default;
  Object.defineProperty(v, "__esModule", {
    value: !0
  }), v.default = J;
  var j = t(oe), q = t(le), y = t(ie), A = t(ne), F = t(de), I = t(fe), d = me, L = t(ue), M = t(ve), Q = ce, H = t(se), K = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, V = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Z = /^'([^]*?)'?$/, B = /''/g, G = /[a-zA-Z]/;
  function J(o, l, e) {
    var s, m, c, p, _, x, g, k, w, E, O, h, D, $, R, C, S, W;
    (0, M.default)(2, arguments);
    var U = String(l), i = (0, Q.getDefaultOptions)(), n = (s = (m = e == null ? void 0 : e.locale) !== null && m !== void 0 ? m : i.locale) !== null && s !== void 0 ? s : H.default, P = (0, L.default)((c = (p = (_ = (x = e == null ? void 0 : e.firstWeekContainsDate) !== null && x !== void 0 ? x : e == null || (g = e.locale) === null || g === void 0 || (k = g.options) === null || k === void 0 ? void 0 : k.firstWeekContainsDate) !== null && _ !== void 0 ? _ : i.firstWeekContainsDate) !== null && p !== void 0 ? p : (w = i.locale) === null || w === void 0 || (E = w.options) === null || E === void 0 ? void 0 : E.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
    if (!(P >= 1 && P <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var T = (0, L.default)((O = (h = (D = ($ = e == null ? void 0 : e.weekStartsOn) !== null && $ !== void 0 ? $ : e == null || (R = e.locale) === null || R === void 0 || (C = R.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && D !== void 0 ? D : i.weekStartsOn) !== null && h !== void 0 ? h : (S = i.locale) === null || S === void 0 || (W = S.options) === null || W === void 0 ? void 0 : W.weekStartsOn) !== null && O !== void 0 ? O : 0);
    if (!(T >= 0 && T <= 6))
      throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!n.localize)
      throw new RangeError("locale must contain localize property");
    if (!n.formatLong)
      throw new RangeError("locale must contain formatLong property");
    var f = (0, y.default)(o);
    if (!(0, j.default)(f))
      throw new RangeError("Invalid time value");
    var X = (0, I.default)(f), b = (0, q.default)(f, X), ee = {
      firstWeekContainsDate: P,
      weekStartsOn: T,
      locale: n,
      _originalDate: f
    }, re = U.match(V).map(function(r) {
      var a = r[0];
      if (a === "p" || a === "P") {
        var u = F.default[a];
        return u(r, n.formatLong);
      }
      return r;
    }).join("").match(K).map(function(r) {
      if (r === "''")
        return "'";
      var a = r[0];
      if (a === "'")
        return N(r);
      var u = A.default[a];
      if (u)
        return !(e != null && e.useAdditionalWeekYearTokens) && (0, d.isProtectedWeekYearToken)(r) && (0, d.throwProtectedError)(r, l, String(o)), !(e != null && e.useAdditionalDayOfYearTokens) && (0, d.isProtectedDayOfYearToken)(r) && (0, d.throwProtectedError)(r, l, String(o)), u(b, r, n.localize, ee);
      if (a.match(G))
        throw new RangeError("Format string contains an unescaped latin alphabet character `" + a + "`");
      return r;
    }).join("");
    return re;
  }
  function N(o) {
    var l = o.match(Z);
    return l ? l[1].replace(B, "'") : o;
  }
  Y.exports = v.default;
})(z, z.exports);
var pe = z.exports;
const ze = /* @__PURE__ */ te(pe);
export {
  ze as default
};
